import type { FC } from "react";
import React from "react";
import classNames from "classnames";
import ArenkoIdentSvg from "./ArenkoIdentSvg";
import css from "./LogoLoader.module.css";

type LogoLoaderProps = {
  className?: string;
  label?: string;
  mode?: "loop" | "longCharge";
  size?: "sm" | "md" | "lg";
  speed?: "slow" | "medium" | "fast";
};

const LogoLoader: FC<LogoLoaderProps> = ({
  className,
  label = "Loading",
  mode = "loop",
  size = "md",
  speed = "medium",
}) => {
  return (
    <div
      className={classNames(
        css.container,
        css[size],
        css[speed],
        mode === "longCharge" && css.longCharge,
        className
      )}
      role="progressbar"
      aria-busy="true"
      aria-label={label}
    >
      <ArenkoIdentSvg title="Loading" />
    </div>
  );
};

export default LogoLoader;
